import React, { FC, useEffect, useState } from 'react';
import Styles from './StaticLineTable.module.scss';
import { CheckoutButtonSchema } from './StaticProductDatatypes';
import GenericModal from '../LineCheckV3/GenericModal';
import WorldPassPopup from './WorldPassPopup';
import { CONTRACT, ICONIC_FLEX_UPGRADE_BENEFIT, ONE_ECOMMERCE_HARDWARE_SUMMARY } from '../../utils/constants';
import ToolTip from '../ToolTip/ToolTip';
import RichText from '../richtext';

const CheckoutButton: FC<CheckoutButtonSchema> = ({
  isMobileFlow,
  createCartCall,
  constants,
  storyContent,
  showPrice,
  isAvailable,
  address,
  alwaysActive,
  uniqueProductBenefits,
  flexUpgradeFreePopup,
  content,
  deviceUltimateBundle,
  forceDisabled,
  notEligibileReason
}) => {
  const [showFlexPopUp, setShowFlexPopUp] = useState<boolean>(false);
  const [isDisabled, setDisabled] = useState<boolean>(false);
  const [sessionFlexData, setSessionFlexPrice] = useState<any>('')

  const handleClose = () => {
    setShowFlexPopUp(!showFlexPopUp);
  };

  const handlePopup = () => {
    if (content?.redirectOnly && content?.productBasedCheckoutUrl?.url) {
      window.location.href = content?.productBasedCheckoutUrl?.url;
    } else if (
      uniqueProductBenefits?.benefits?.length > 0 &&
      uniqueProductBenefits?.benefits?.includes(ICONIC_FLEX_UPGRADE_BENEFIT) &&
      sessionFlexData?.hardwareVariant?.selectedContractType === CONTRACT
    ) {
      setShowFlexPopUp(true);
    } else {
      createCartCall();
    }
  };

  useEffect(() => {
    if (forceDisabled || (!isMobileFlow && !isAvailable && !alwaysActive) || showPrice?.base === '' || (deviceUltimateBundle && !uniqueProductBenefits?.eligibility?.fpb) || notEligibileReason) {
      setDisabled(true);
    } else {
      setDisabled(false);
    }
  }, [storyContent, showPrice, isAvailable, forceDisabled, notEligibileReason]);

    useEffect(() => {
      const obj = sessionStorage.getItem(ONE_ECOMMERCE_HARDWARE_SUMMARY);
      const sessionData = obj && JSON.parse(obj);
      setSessionFlexPrice(sessionData);
    }, []);

    
  return (
    <div>
      {isMobileFlow ? (
        storyContent?.swapButton ? (
          storyContent?.ctaLinkLabel && (
            <a onClick={createCartCall} className={`${isDisabled && Styles.disabled}`}>
              {storyContent?.ctaLinkLabel}
            </a>
          )
        ) : (
          <>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <button
                className={`primarybutton ${isDisabled && Styles.disabled}`}
                onClick={handlePopup}
                disabled={isDisabled}
                style={{ flex: 1 }}
              >
                <span className={Styles.buttontext}>{constants?.addToCartBtnTxt}</span>
              </button>
              {notEligibileReason && constants?.notEligibleTooltipBody && (
                <ToolTip
                  content={<RichText content={constants?.notEligibleTooltipBody} />}
                  heading={constants?.notEligibleTooltipHeading
                    ? <RichText content={constants?.notEligibleTooltipHeading} />
                    : ''}
                  variant='error'
                />
              )}
            </div>

            {sessionFlexData?.hardwareVariant?.selectedContractType === CONTRACT &&
                showFlexPopUp &&
                flexUpgradeFreePopup?.body?.length > 0 && (
                  <GenericModal
                    modalState={showFlexPopUp}
                    handler={handleClose}
                    showFooter={false}
                    width={'600px'}
                    height='auto'
                    backgroundColor='#ffffff'
                    noCloseButton={false}
                    backDrop={true}
                    bodyPadding='16px'
                  >
                    <WorldPassPopup
                      storyContent={flexUpgradeFreePopup}
                      createCartCall={createCartCall}
                      setShowFlexPopUp={setShowFlexPopUp}
                      sessionFlexData={sessionFlexData}
                    />
                  </GenericModal>
                )}
          </>
        )
      ) : (
        <>
          {address && Object?.keys(address)?.length > 0 && !alwaysActive ? (
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <button
                className={`primarybutton ${isDisabled && Styles.disabled}`}
                onClick={createCartCall}
                disabled={isDisabled}
              >
                <span className={Styles.buttontext}>{constants?.addToCartBtnTxt}</span>
              </button>
              {notEligibileReason && constants?.notEligibleTooltipBody && (
                <ToolTip
                  content={<RichText content={constants?.notEligibleTooltipBody} />}
                  heading={constants?.notEligibleTooltipHeading
                    ? <RichText content={constants?.notEligibleTooltipHeading} />
                    : ''}
                  variant='error'
                />
              )}
            </div>
          ) : (
            <button onClick={createCartCall} className='configurebutton'>
              <span>{constants?.checkAvailability}</span>
            </button>
          )}
        </>
      )}
    </div>
  );
};

export default CheckoutButton;
